import { render, staticRenderFns } from "./rezo.vue?vue&type=template&id=56ecbcca&scoped=true"
import script from "./rezo.vue?vue&type=script&lang=js"
export * from "./rezo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ecbcca",
  null
  
)

export default component.exports